import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { LeakScoreStatus } from '@app/core/enums/leak-score-status.enum';

@Component({
  selector: 'gc-ld-logger-noise-leak-score-gauge',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './ld-logger-noise-leak-score-gauge.component.html',
  host: {
    class: 'flex items-center justify-center shrink-0',
  },
})
export class LdLoggerNoiseLeakScoreGaugeComponent {
  public status = input.required<LeakScoreStatus | undefined>();
  public width = input<number>(36);

  protected readonly defaultColor = 'var(--p-other-opacity-gray-100-50)';

  public height = computed(() => (this.width() * 13) / 36);

  public leakState = computed(() => {
    switch (this.status()) {
      case LeakScoreStatus.Critical:
        return { color: 'var(--p-other-red-500)', level: 3 };
      case LeakScoreStatus.Warn:
        return { color: 'var(--p-orange-500)', level: 2 };
      case LeakScoreStatus.Normal:
        return { color: 'var(--p-other-green-500)', level: 1 };
      default:
        return { color: this.defaultColor, level: 0 };
    }
  });
}
